import useCheckoutSession from '../hooks/useCheckoutSession';
import React, {useEffect, useState} from 'react';
import {Box, CircularProgress, Typography} from '@mui/material';
import * as LogicService from '../services/LogicService';
import * as CommunicationService from '../services/CommunicationService';

export default function TeregoPromotionReturn({checkoutScope = 'comenzi'}) {
    const session = useCheckoutSession(checkoutScope);
    const [status, setStatus] = useState('PENDING_TEREGO');
    const order = session.getOrder();

    useEffect(() => {
        if (!order || !order.id || !order.promotionAccessToken) {
            setStatus('FAILED');
            return undefined;
        }
        let active = true;
        let timer;
        const poll = () => CommunicationService.getTeregoPromotionStatus(order.id, order.promotionAccessToken)
            .then(response => {
                if (!active || !session.isCurrent()) return;
                setStatus(response.promotionStatus);
                if (response.promotionStatus === 'COMPLETED') {
                    session.updateOrderState('THANKS');
                    return;
                }
                if (!['FAILED', 'EXPIRED', 'CANCELLED'].includes(response.promotionStatus)) {
                    timer = window.setTimeout(poll, 5000);
                }
            })
            .catch(() => active && setStatus('FAILED'));
        poll();
        return () => { active = false; window.clearTimeout(timer); };
    }, []);

    return (
        <Box sx={{p: 5, textAlign: 'center'}}>
            {status === 'PENDING_TEREGO' && <CircularProgress />}
            <Typography variant="h5" sx={{mt: 2}}>
                {status === 'COMPLETED' ? 'Cazierul judiciar va fi finalizat și confirmat prin email.' :
                    status === 'FAILED' ? 'Nu am putut confirma profilul Terego. Te rugăm să încerci din nou.' :
                        'Așteptăm confirmarea profilului Terego.'}
            </Typography>
        </Box>
    );
}
